module.exports = __webpack_public_path__ + "static/img/sdjnszx.0f1a3cf.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/participationCenter/sdjnszx.png
// module id = dAoU
// module chunks = 0